// Iter-200j — Detect the sign-off line (Cordialement, Best regards, etc.)
// in a plain-text reminder body. Used to show the CEO exactly WHERE the
// "Déclarer le paiement de cette facture" CTA banner will be injected so
// they can reorganize their template without surprises.
//
// Mirror of `_inject_before_signoff` in backend/lib/payment_cta_banner.py.

const SIGNOFF_REGEX =
  /^\s*(cordialement|bien\s+(?:à|a)\s+vous|bien\s+cordialement|best\s+regards|sincerely|[—–-]\s*BAIM)\b.*$/im;

export function detectSignoffLine(text) {
  if (!text) return null;
  const m = SIGNOFF_REGEX.exec(text);
  if (!m) return null;
  // Return both the matched line and its 0-based line number (for UI hints).
  const lineNumber = text.slice(0, m.index).split("\n").length;
  return {
    line: m[0].trim(),
    lineNumber,
    fullMatch: m[0],
  };
}
